import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

import FieldSelect from '../common/FieldSelect';
import FieldText from '../common/FieldText';

import Util from '../../util/Util';
import RoomController from '../../controller/RoomController';
import RoomAPI from '../../api/RoomAPI';


class RoomPopup extends React.Component {

  constructor(props) {
    super(props);
    this.model = props.model;
    this.room = RoomController.addModel(this.model.fields);
    this.room.project_id = props.project;
    this.room.tower_id = props.tower.id;
    this.room.id = 0;
    
    this.state = { inValid: {}, room: { ...this.room } };
  }

  onReceived = (res) =>{
    this.room.property = res.data;
    this.setState({ ...this.state, inValid: {}, room: { ...this.room } });
  }

  UNSAFE_componentWillReceiveProps(props) {
    if(props && props.room && props.room.id !== this.state.room.id) {
      this.setState({ ...this.state, room: { ...props.room }});
    } else if(props.room === null) { this.setState({ ...this.state, room: { ...this.room }}); }

    if(props.model_id !== this.state.model_id) {
      this.room = { ...this.room, model_no: props.model_no, model_id: props.model_id };
    }
    if(props.room && props.room.id !== this.state.room.id) {
      this.setState({ ...this.state, room: { ...props.room }});
    } else if(!props.room) { this.setState({ ...this.state, room: { ...this.room }}); }
  }

  onChange = (field, value) => {
    const room = { ...this.state.room };
    room[field] = value;
    this.setState({ ...this.state, room: { ...room }});
  }

  onSave = () => {
    RoomAPI.saveRoom(this.state.room, this.onSaved, this.props.failure, this.props.logout);
    this.setState({ ...this.state, inApiCall: true });
  }

  onSaved = res => {
    Util.showNotification('Successful', 'Room saved successfully', 'success');
    this.setState({ ...this.state, room: { ...this.state.room, id: res.id}, inApiCall: false });
    this.props.onHide();
    if(this.props.reload) {
      this.props.reload();
    }
  }

  render() {
    const fields = this.model.fields;
    const inValid = this.state.inValid;
    const room = this.state.room;

    return (
      <Modal aria-labelledby="contained-modal-title-vcenter" size="md" show={this.props.show}
        onHide={this.props.onHide} centered onExit={() => this.isAPICalled = false }>
        
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Room Configuration</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>

            <FieldText key="room_name" id="room_name" field={fields.room_name}
              value={room.room_name} onValueChange={this.onChange} inValid={inValid} />

            <FieldText key="floor_no" id="floor_no" field={fields.floor_no}
              value={room.floor_no} onValueChange={this.onChange} inValid={inValid} />

            <FieldSelect key="property" id="property" field={fields.property}
              value={room.property} onValueChange={this.onChange} inValid={inValid} />

            <FieldSelect key="room_status" id="room_status" field={fields.room_status}
              value={room.room_status} onValueChange={this.onChange} inValid={inValid} />

          </Form>
        </Modal.Body>

        <Modal.Footer><Button onClick={this.onSave}>Submit</Button></Modal.Footer>
      </Modal>
    );
  }
}
export default RoomPopup;